module.exports = __webpack_public_path__ + "static/media/riskcase2.b74dbd0b.png";